<template>
  <div class="relative">
    <slot />
    <div
      v-if="isLocked"
      class="absolute inset-0 cursor-not-allowed"
      @click="handleClick"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '@app/views/Review/use-review'
import { AuthKey } from '@app/injectionKeys'
import { Role } from '@core/domain/types/role.type'
import { ReviewLockState } from '@core/domain/types/reviewLockState.type'
import useSnackbar from '@app/composables/use-snackbar'
import { SnackbarState } from '@app/types'

const review = injectStrict(ReviewKey)
const auth = injectStrict(AuthKey)
const snackbar = useSnackbar()

const isLocked = computed(() => review.isPlanReadonly.value)

const warningMessage = computed(() => {
  const isAdmin = auth.user.value?.role === Role.ADMIN

  if (
    review.entity.value.plan?.lockState === ReviewLockState.LOCKED &&
    !review.isLocked.value
  ) {
    return isAdmin
      ? 'The plan is locked, unlock it to make changes.'
      : 'The plan is locked. Please contact an admin to make changes.'
  }

  if (review.isLocked.value) {
    return isAdmin
      ? 'The review is locked, unlock it to make changes.'
      : 'The review is locked. Please contact an admin to make changes.'
  }

  return ''
})

function handleClick(event: Event) {
  if (isLocked.value && warningMessage.value) {
    event.stopPropagation()
    event.preventDefault()
    snackbar.show(SnackbarState.ERROR, warningMessage.value)
  }
}
</script>
